export default {
  data() {
    return {};
  },
  computed: {
    footerText() {
      return this.$store.state.settings.footer_text;
    },
  },
};
